import React, { useState, useEffect } from 'react';
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  Avatar,
  User,
} from '@nextui-org/react';
import { Modal, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/features/auth/authActions';
import { decryptData } from '../../utils/encryptData';
import { formatName } from '../../utils/nameFormatter';
import { Link } from 'react-router-dom';
import { persistor } from '../../redux/store';
import { PrivateAxiosInstance } from '../../services/createAxiosInstance';
import { URLs } from '../../constants/apiEndpoints';

function ProfileDropdown({}) {
  const [isVerifydUser, setIsVerifydUser] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get isAuthenticated and email from Redux store
  const { isAuthenticated, em, rl, uid, verify, username } = useSelector(
    (state) => state.auth
  );

  const email = decryptData(em);
  const role = decryptData(rl);
  const userId = decryptData(uid);

  useEffect(() => {
    const getVerifyStatus = async () => {
      if (verify) {
        setIsVerifydUser(true);
      } else {
        try {
          const res = await PrivateAxiosInstance.get(
            URLs.CHECK_USER_VERIFIED_URL
          );
          const isVerify = res?.data;

          if (!isVerify) {
            return;
          }

          if (isVerify.error === 'User is not verified') {
            return;
          }

          if (isVerify === 'verified') {
            setIsVerifydUser(true);
          }
        } catch (error) {
          console.error(error);
        }
      }
    };
    getVerifyStatus();
  }, []);

  // Logout handler
  const handleLogout = async () => {
    if (!isAuthenticated && !em && !rl) {
      message.success('You are already logout!'); // check before logout user is alredy login
      return;
    }

    // const email = await decryptData(em); // decrypt email

    if (!email === null) {
      message.error('Something went wrong!');
      return;
    }

    try {
      await dispatch(logout({ email })).unwrap();
      message.success('Successfully logged out!');
      persistor.purge(); // Clear persisted data
      navigate('/'); // Redirect to home page
    } catch (err) {
      const errorMessage = err.error || 'Logout failed';
      message.error(errorMessage);
    }
  };

  // Show confirm modal
  const showConfirm = () => {
    Modal.confirm({
      title: 'Confirm Logout',
      content: 'Are you sure you want to log out?',
      okText: 'Yes!',
      cancelText: 'Cancel',
      onOk() {
        handleLogout();
      },
    });
  };

  const formattedName = formatName(username || ' ');

  return (
    <>
      <div className="flex items-center ">
        {/* sm */}

        <div className="md:hidden">
          <Dropdown placement="bottom-start">
            {/* md */}
            <DropdownTrigger>
              <Avatar
                isBordered
                as="button"
                className="transition-transform"
                name={username}
              />
            </DropdownTrigger>

            <DropdownMenu aria-label="User Actions" variant="flat">
              <DropdownItem key="profile" className="h-14 gap-2">
                <p className="font-bold">Signed in as</p>
                <p className="font-semibold">{email}</p>
              </DropdownItem>
              <DropdownItem key="change_password">
                <Link to={'/forgot-password'}>Change Password</Link>
              </DropdownItem>
              <DropdownItem
                key="logout"
                color="danger"
                onClick={showConfirm}
                className="text-danger"
              >
                Log Out
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>

        <div className="hidden md:block">
          <Dropdown placement="bottom-start">
            {/* md */}
            <DropdownTrigger>
              <User
                as="button"
                avatarProps={{
                  isBordered: true,
                  name: formattedName.lastName,
                }}
                description={`${role} | ${userId}`}
                name={username ? formattedName.shortname : role}
                className="font-poppins capitalize text-white transition-transform"
              />
            </DropdownTrigger>

            <DropdownMenu aria-label="User Actions" variant="flat">
              <DropdownItem key="profile" className="h-14 gap-2">
                <p className="font-bold">Signed in as</p>
                <p className="font-semibold">{email}</p>
              </DropdownItem>

              <DropdownItem key="change_password">
                <Link to="/edit-profile">Edit Profile</Link>
              </DropdownItem>

              <DropdownItem key="change_password">
                <Link to={'/forgot-password'}>Change Password</Link>
              </DropdownItem>
              <DropdownItem
                key="logout"
                color="danger"
                onClick={showConfirm}
                className="text-danger"
              >
                Log Out
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </>
  );
}

export default ProfileDropdown;
